import React from 'react';

import { AccountAlert, AccountLink } from './AccountExistsAlert.styled';
import { pageUrl } from 'utilities/pageUrl';

export const AccountExistsAlert = () => (
  <AccountAlert
    type="info"
    size="md"
    noShadow
    message={
      <em>
        If you've previously created a patient portal account, try{' '}
        <AccountLink to={pageUrl.login()}>logging in</AccountLink> or{' '}
        <AccountLink to={pageUrl.passwordReset()}>recovering your account</AccountLink>. If you
        don't have an account, you can continue creating one below.
      </em>
    }
  />
);
